// Thin client-side wrapper around the `notify-settings-changed` Edge Function.
//
// Each calling feature (BudgetDrawer, NewCreativeModal, CreativeScreen) owns
// its own markdown formatting for `previousState` / `newState` and pipes the
// result through here so all four call sites share one transport contract:
//
//   notifyChange({ supabase, eventType, advertiserId, previousState, newState })
//
// Errors are intentionally swallowed (logged at warn level). A Clarify or
// Zapier outage must never block the user-visible save flow from completing.
// The Edge Function itself short-circuits @audiohook.com JWTs as defense-in-
// depth, but callers should still gate on `!isSupportUser` to avoid the
// round-trip when the answer is going to be "skipped".

export function notifyChange({
  supabase,
  eventType,
  advertiserId,
  previousState = "",
  newState,
}) {
  if (!supabase || advertiserId == null || !eventType || typeof newState !== "string") {
    return Promise.resolve();
  }
  return supabase.functions
    .invoke("notify-settings-changed", {
      body: {
        event_type: eventType,
        advertiser_id: advertiserId,
        previous_state: previousState,
        new_state: newState,
      },
    })
    .catch((e) => {
      console.warn("notify-settings-changed failed", e);
    });
}
